import { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { MessageCard } from './';
import { SearchBar } from 'components/IconTextField';
import { Conversation } from 'types/conversation';
import { UnreadMessageInfo } from 'types/notification';
import { getReceiver } from 'helper/conversation';

export const RoomList: React.FC<{
  conversations: Array<Conversation>;
  unreadMessages: { [roomId: string]: UnreadMessageInfo };
  userId: string;
  roomId: string;
  handleConversationRoom: (id: string) => void;
}> = ({
  conversations,
  unreadMessages,
  userId,
  roomId,
  handleConversationRoom,
}) => {
  const [roomList, setRoomList] = useState<Array<Conversation>>(conversations);
  const cardInfo =conversations.map((item) => ({
    roomId: item.roomId as string,
    name: getReceiver(item, userId),
  }));

  useEffect(() => {
    setRoomList(conversations);
  }, [conversations]);

  const checkIsRead = (room: string) => {
    if (!unreadMessages) return true;
    return !unreadMessages[room];
  };

  const handleSearch = (searchTerm: string) => {
    const roomIds = cardInfo
    .filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLocaleLowerCase())
    ).map((item) => item.roomId);
    setRoomList(conversations.filter((item) =>roomIds.includes(item.roomId as string)));
  };

  return (
    <>
      <Box>
        <Typography variant="h5" sx={{ marginBottom: '10px' }}>
          訊息
        </Typography>
      < SearchBar
        handleSumbit = {handleSearch}
        hint = {"搜尋推薦人名稱"}
        InputPropsStyle = {{ height: '34px', borderRadius: '30px', fontSize: '16px',}}
        sx = {{ backgroundColor: '#fff', borderRadius: '30px', margin: '0 0',}}
      />
      </Box>
      {roomList.length > 0 && (
        <Box>
          {roomList.map((item) => (
            <Box
              key={item.roomId}
              onClick={() => handleConversationRoom(item.roomId as string)}
            >
              <MessageCard
                avatar=""
                name={getReceiver(item, userId as string)}
                lastMessage={item.lastMessage}
                isRead={checkIsRead(item.roomId ?? '')}
                active={item.roomId === roomId}
                isMe={item.lastMessage.sender === userId}
              />
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};
